// src/features/admin-templates/pages/TemplateAdminPage.jsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import { Assignment as AssignmentIcon, MedicalServices as MedicalServicesIcon } from '@mui/icons-material';
import TaskTemplatesPanel from '../components/TaskTemplatesPanel';
import EquipmentTemplatesPanel from '../components/EquipmentTemplatesPanel';
import { useTemplateAdminPermissions } from '../../auth/hooks/usePermissions';

import PageHeader from '../../../components/common/PageHeader';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export default function TemplateAdminPage() {
  const { t } = useTranslation(['common']);
  const [activeTab, setActiveTab] = useState(0);
  const { canRead } = useTemplateAdminPermissions();

  if (!canRead) {
    return (
      <Box>
        <Typography color="text.secondary">{t('common:errors.forbidden')}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <PageHeader icon={LibraryBooksIcon} title={t('common:navigation.template_admin')} subtitle={t('common:page_subtitles.template_admin')} />

      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={t('common:navigation.task_templates')} icon={<AssignmentIcon />} iconPosition="start" />
          <Tab label={t('common:navigation.equipment_templates')} icon={<MedicalServicesIcon />} iconPosition="start" />
        </Tabs>
      </Paper>

      <TabPanel value={activeTab} index={0}>
        <TaskTemplatesPanel />
      </TabPanel>
      <TabPanel value={activeTab} index={1}>
        <EquipmentTemplatesPanel />
      </TabPanel>
    </Box>
  );
}
